@if (currentCurrency(); as currentCurrency) {
  <div class="flex flex-col justify-between">
    <div class="flex flex-col gap-1 py-2">
      <div class="text-xl leading-none font-semibold tracking-tight">Devise préférée</div>
      <div class="text-gray-11">{{ currentCurrency.currency }}</div>
    </div>
  </div>
}
